const getNotificationsAPI = (currentPage, pageSize) =>
  `api/notifications?currentPage=${currentPage}&pageSize=${pageSize}`;

const markAsReadNotificationsAPI = () => 'api/notifications';

const deleteNotificationsAPI = () => 'api/notifications';

const deleteNotificationAPI = (id) => `api/notifications/${id}`;

const markReadAllNotificationsAPI = () => 'api/notifications/change-notification-status/all?markAsRead=true';

export const notificationsEndpoints = {
  getNotificationsAPI,
  markAsReadNotificationsAPI,
  deleteNotificationsAPI,
  markReadAllNotificationsAPI,
  deleteNotificationAPI,
};
